import { SETTINGS_BODY_DIV } from "../../../../assets/styles/classes-constants";
import { COLORS } from "../../../../assets/utils/enums/colors";
import { LittleSubHeadline, MediumText, NotificationText, SubTitle } from "../../../../components/typography";
import { Button } from "../../../../components/ui/button";
import { FixedBodyDiv, TitleSpan } from "../team/view-team"; import deleteIcon from "../../../../assets/images/icons/delete-icon.svg";
import { Block } from "../../main";
import textIcon from "../../../../assets/images/icons/structure-object/text-icon.svg"
import Input from "../../../../components/ui/inputs";
import { useEffect, useState } from "react";

export default function ManagementSettingsTab() {
    const name: string = "Name of company";
    const [changedName, setChangedName] = useState<string>(name);
    const [isChanged, setIsChanged] = useState<boolean>(false);

    useEffect(() => {
        setIsChanged(changedName === name || changedName === "");
    }, [changedName])

    return (
        <FixedBodyDiv
            className={`w-60 ${SETTINGS_BODY_DIV} justify-content-between`}
            $isPadding={true}
        >
            <Block className="w-100">
            <TitleSpan>
                <SubTitle>Керування робочим простором</SubTitle>
                <NotificationText>Тут ви можете змінити назву команди або видалити робочий простір.</NotificationText>
                <NotificationText className="warning-text"><b>Зверніть увагу:</b> видалення робочого простору є <u>незворотним</u> і призведе до <u>втрати всіх даних.</u></NotificationText>
            </TitleSpan>
                <Block
                    className={`w-100 d-flex align-items-center justify-content-between border-bottom pb-2 gap-4`}
                >
                    <span className="d-flex align-items-center gap-2 w-50">
                        <img src={textIcon} alt="text-icon" width={32} height={32} />
                        <MediumText>Назва команди</MediumText>
                    </span>
                    <Input
                        attribute="text"
                        value={changedName}
                        setValue={setChangedName}
                        errorText={""}
                        label=""
                        placeholder={name}
                    />
                </Block>
                <Block
                    className={`w-100 d-flex align-items-center justify-content-between pt-3`}
                >
                    <Button
                        bgcolor={"transparent"}
                        txtcolor={COLORS.secondary1}
                        brcolor={"transparent"}
                        type="large"
                        width="auto"
                        className="d-flex align-items-center gap-2 text px-0"
                    >
                        <img src={deleteIcon} alt="delete-icon" />
                        <MediumText>Видалити робочий простір</MediumText>
                    </Button>
                    <Button
                        bgcolor={COLORS.warning}
                        txtcolor={COLORS.white}
                        brcolor={"transparent"}
                        type="small"
                        brradius="12px"
                        width="auto"
                        className="d-flex align-items-center gap-2"
                    //   onClick={deleteActionWindow}
                    >
                        <MediumText>Видалити</MediumText>
                    </Button>
                </Block>
            </Block>
            <Button
                bgcolor={COLORS.secondary1}
                txtcolor={`${COLORS.white} !important`}
                brcolor={"transparent"}
                width="35%"
                type="large"
                brradius="24px"
                disabled={isChanged}
                $noactive={isChanged}
                onClick={() => { }}
            >
                <LittleSubHeadline>Підтвердити зміни</LittleSubHeadline>
            </Button>
        </FixedBodyDiv>
    )
}